import { types } from 'mobx-state-tree';

export interface RoleReqAnswerType {
  id: string | null;
  globalId: string | null;
  text: string;
  isVerified: boolean;
}

const RoleReqAnswer = types
  .model('RoleReqAnswer', {
    id: types.maybeNull(types.string),
    globalId: types.maybeNull(types.string),
    text: types.string,
    isVerified: types.boolean,
  })
  .views((self) => ({
    get globalIdOrId() {
      return self.globalId ?? (self.id as string);
    },
  }));

export default RoleReqAnswer;
